import { Component, Inject, OnInit, signal, WritableSignal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IdName } from '../../../../../interfaces/pricematrixmodel';
import { MetalsInputData } from '../../../../../interfaces/streamrecurringLoad';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FeedstockService } from '../../../../../services/feedstockservice';
import { LookUpService } from '../../../../../services/lookupservice';
import { GetLabMetalsByIdResponse, LabMetalsList, SaveStreamBiologyMetalsRequest } from '../../../../../interfaces/labmetalsmodel';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule, MatCardActions } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { formatDateOnly, normalizeNullable, numericInputLimit } from'../../../../shared/commonutils/helper';
import { MatDialogModule } from '@angular/material/dialog'; 
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-addedit-metals',
  imports: [
    CommonModule,
    ReactiveFormsModule, // FIX: ngModel error
    MatCardModule,
    MatFormFieldModule, // FIX: mat-form-field error
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    DragDropModule
  ],
  templateUrl: './addedit-metals.component.html',
  styleUrl: './addedit-metals.component.scss'
})
export class AddeditMetalsComponent implements OnInit {
  task: string = "Add";
  metalsForm!: FormGroup;
  attemptSave = signal(false);
  isSaving = signal(false);
  dateError = signal<boolean>(false); 
  isEditMode = signal<boolean>(false);
  streamID = signal<number | null>(null);
  genId = signal<number | null>(null);
  labTypes = signal<IdName[]>([]);  
  testingTypes: WritableSignal<IdName[]> = signal([]);
  inputTypes: WritableSignal<IdName[]> = signal([]);
  displayValue = signal<string>('');
  isInpuTypeDisable : boolean = false;
  canSave: boolean = false;

  constructor(private fsService: FeedstockService,
    private lookup: LookUpService,
    public dialogRef: MatDialogRef<AddeditMetalsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MetalsInputData,
    private cForm: FormBuilder,private dialog: MatDialog) { 

      console.log("metals Dialog data:", data);
      this.streamID.set(data.streamId);
      this.genId.set(data.genId);
      this.task = data.task;
      this.canSave = data.canSave;
      if(this.task === 'Edit' && data.inputData){
        this.isInpuTypeDisable = true;
      }
      if(data.inputData){  
        this.isEditMode.set(true);
      }
    }

  ngOnInit(): void {
    
    this._initializeForm();
    this.loadDropdownData();
  }  

  private _initializeForm(): void {
    this.metalsForm = this.cForm.group({
      id: 0,
      m_StreamID: this.streamID(),
      m_LabId: [null, Validators.required],
      testingType: [null, Validators.required],
      m_SampleID: ['', Validators.maxLength(15)],
      m_LabreportID: ['', [Validators.required, Validators.maxLength(15)]],
      m_DateSampled: [new Date()],
      m_DateTested: [new Date()],
      metalInput: [null],
      ts_mg_L: null,
      as_Dry: ['', Validators.maxLength(10)],
      cd_Dry: ['', Validators.maxLength(10)],
      cr_Dry: ['', Validators.maxLength(10)],
      co_Dry: ['', Validators.maxLength(10)],
      cu_Dry: ['', Validators.maxLength(10)],
      pb_Dry: ['', Validators.maxLength(10)],
      hg_Dry: ['', Validators.maxLength(10)],
      mo_Dry: ['', Validators.maxLength(10)],
      ni_Dry: ['', Validators.maxLength(10)],
      se_Dry: ['', Validators.maxLength(10)],
      zn_Dry: ['', Validators.maxLength(10)],
      notes: ['', Validators.maxLength(3000)],
    });
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    
    val = numericInputLimit(event, maxValue, maxDecimals);
    
    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    if (isValueEmpty) {
      this.metalsForm.get(controlName)?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      this.metalsForm.get(controlName)?.setErrors({ 'incompleteDecimal': true });
    } else {      
      const parsedValue = parseFloat(val);
      this.metalsForm.get(controlName)?.setValue(parsedValue, { emitEvent: false });
    }
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
          input.value = val;
      }
    });
  }

  loadDropdownData() {    
    this.lookup.getLabTypes().subscribe({
      next: (data: IdName[]) => {
        this.labTypes.set(data);
        if(this.isEditMode()){
          this.populateFormData(this.data.inputData);
        }
      }
    });
    
    this.lookup.getSampleFrequencyLookup().subscribe({
      next: async (response) => {
        this.testingTypes.set(response.filter(item => item.type === 'PermitType'));
        this.inputTypes.set(response.filter(item => item.type === 'InputType'));
      }
    })
  }

  populateFormData(data: LabMetalsList | null): void {
    console.log("loading edit data metals");
    if(data){
      this.fsService.getMetalsDataById(data.id).subscribe(
        {
          next: (res: GetLabMetalsByIdResponse) => {
            console.log("metals data by id", res);

            if(this.isEditMode()){
              this.metalsForm.get('metalInput')?.disable();
            }
            
            let ipType = this.inputTypes().find(item => item.id === parseInt(res.metalInput))?.name || null;
            const formData = {
              id: res.id,
              m_StreamID: res.m_StreamID,
              m_LabId: res.m_LabId,
              testingType: res.testingType,
              m_SampleID: res.m_SampleID,
              m_LabreportID: res.m_LabreportID,
              m_DateSampled: res.m_DateSampled,
              m_DateTested: res.m_DateTested,
              metalInput: res.metalInput,
              ts_mg_L: res.tS_mg_L,
              as_Dry: res.as,
              cd_Dry: res.cd,
              cr_Dry: res.cr,
              co_Dry: res.co,
              cu_Dry: res.cu,
              pb_Dry: res.pb,
              hg_Dry: res.hg,
              mo_Dry: res.mo,
              ni_Dry: res.ni,
              se_Dry: res.se,
              zn_Dry: res.zn,
              notes: res.notes
            };  
            this.metalsForm.patchValue(formData);
          }
        }
      );      
    }
  }
    
  buildPayload(): SaveStreamBiologyMetalsRequest {
    const formData = this.metalsForm.getRawValue();
    return {
    id: formData.id,
    m_StreamID: this.streamID()!,
    m_LabId: normalizeNullable(formData.m_LabId),
    testingType: normalizeNullable(formData.testingType),
    m_SampleID: formData.m_SampleID,
    m_LabreportID: formData.m_LabreportID,
    m_DateSampled: formatDateOnly(formData.m_DateSampled),
    m_DateTested: formatDateOnly(formData.m_DateTested),
    metalInput: formData.metalInput ? String(formData.metalInput) : null,
    ts_mg_L: normalizeNullable(formData.ts_mg_L),
    as: normalizeNullable(formData.as_Dry),
    cd: normalizeNullable(formData.cd_Dry),
    cr: normalizeNullable(formData.cr_Dry),
    co: normalizeNullable(formData.co_Dry),
    cu: normalizeNullable(formData.cu_Dry),
    pb: normalizeNullable(formData.pb_Dry),
    hg: normalizeNullable(formData.hg_Dry),
    mo: normalizeNullable(formData.mo_Dry),
    ni: normalizeNullable(formData.ni_Dry),
    se: normalizeNullable(formData.se_Dry),
    zn: normalizeNullable(formData.zn_Dry),
    notes: formData.notes
    } as SaveStreamBiologyMetalsRequest;
  }  
  
  saveMetals(): void {
    this.attemptSave.set(true);

    if (!this.validate()) {
      this.metalsForm.markAllAsTouched();
      return;
    }

    this.isSaving.set(true);
    const payload = this.buildPayload();
    console.log("metals saving", payload);
    this.dialogRef.close(true);
    this.fsService.saveMetals(payload).subscribe({
      next: (ok) => {
        this.isSaving.set(false);
        this.dialogRef.close(true);
      }
    });
  }
  
  validate(): boolean {
    let isBaseFormValid = this.metalsForm.valid;
    return isBaseFormValid;
  }

  close(): void {
    this.dialogRef.close(false);
  }

}
